/*
  TODO: Send data to API using redux
  TODO: Add better startDate/endDate validation
    - startDate must be today or later
    - endDate must be startDate or later

  TODO: Add segmentType to backend
  TODO: Add testVariableTimePeriod to backend

  TODO: ask if I should ask these
    - "description" : "postman testing"
    - "status"      : "pending"
*/
import React,{ Component } from 'react';

// Components
import {
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  Button
} from 'reactstrap';
import Form from '../../../shared/components/Form';
import Title from '../../../shared/components/Title';
// import TextInput from '../../../shared/components/TextInput'; 
// import MoneyInput from '../../../shared/components/MoneyInput';
import DateInput from 'react-datepicker';
import moment from 'moment';


// Time Period put into Seconds
// const DAY_IN_SECS = 24 * 60 * 60; // 1 day = 86400 seconds
// const TIME_PERIOD_IN_SECONDS = {
//   day:   DAY_IN_SECS,
//   week:  DAY_IN_SECS * 7,
//   month: DAY_IN_SECS * 30,
// };

class ProviderSegmentationInfo extends Component {

  state = {
    errors: {
      segmentName:                  { state: '', errorMessage: '' },
      segmentType:                  { state: '', errorMessage: '' },
      segmentRetailer:              { state: '', errorMessage: '' },
      startDate:                    { state: '', errorMessage: '' },
      endDate:                      { state: '', errorMessage: '' },
      testPopulationPercent:        { state: '', errorMessage: '' },
      numSegments:                  { state: '', errorMessage: '' },
      // numCampaignsPerSession:       { state: '', errorMessage: '' },
      numCampaignsOverTime:         { state: '', errorMessage: '' },
      numCampaignsTimePeriod:       { state: '', errorMessage: '' },

      totalCampaignValueOverTime:   { state: '', errorMessage: '' },
      totalCampaignValueTimePeriod: { state: '', errorMessage: '' },
      testVariable:                 { state: '', errorMessage: '' },
      testVariableTimePeriod:       { state: '', errorMessage: '' },
      stepAmount:                   { state: '', errorMessage: '' },
      popOffset:                    { state: '', errorMessage: '' },
    },
    currentStartDate:moment(),
    currentEndDate:moment().add(1,'weeks')
  }

  componentDidMount() {
    this.props.loadRetailers();
  }

  validateFormData(formData) {
    // Validate Inputs
    const formErrors = {};
    var hasErrors = false;

    Object.keys(formData).forEach((key,i) => {
      var d = formData[key];

      formErrors[key] = {state: '', errorMessage: ''};

      if (!d && d !== 'description') {
        formErrors[key].state = 'danger';
        formErrors[key].errorMessage = `${key} cannot be empty.`;
        hasErrors = true;
      } else {
        formErrors[key].state = 'success';
        formErrors[key].errorMessage = '';
      }
    });

    return [hasErrors, formErrors];
  }

  handleFormSubmit(formData) {
    // var [hasErrors,formErrors] = this.validateFormData(formData);

    // const finalFormData = {
    //   status:'pending',
    //   name:formData.segmentName,
    //   description:formData.segmentDescription,
    //   retailerId:formData.segmentRetailer,
    //   activeFrom:this.state.currentStartDate.toISOString(),
    //   activeTo:this.state.currentEndDate.toISOString()
    // };

    // if (!hasErrors) {
    //   var finalFormData = {
    //     "status":                 'pending',
    //     "name":                   formData.segmentName,
    //     "description":            formData.segmentDescription,
    //     "retailerId":             formData.segmentRetailer,
    //     "activeFrom":             formData.startDate,
    //     "activeTo":               formData.endDate,
    //   	"testPopPercent":         formData.testPopulationPercent,
    //   	"testPopNumSegment":      formData.numSegments,
    //     "numCampaignsPerPeriod":  formData.numCampaignsOverTime,
    //   	"numCampaignsPeriod":     TIME_PERIOD_IN_SECONDS[formData.numCampaignsTimePeriod.toLowerCase()],
    //     "valuePerPeriod":         formData.totalCampaignValueOverTime,
    //   	"valuePeriod":            TIME_PERIOD_IN_SECONDS[formData.totalCampaignValueTimePeriod.toLowerCase()],
    //   	"testVariable":           formData.testVariable,
    //   	"testPopStep":            formData.stepAmount,
    //     "testPopOffset":          formData.popOffset,

    //     // "numCampaignsPerSession": formData.numCampaignsPerSession,
    //   };

    //   this.props.createSegmentation(finalFormData);
    // }
  }

  render(){
    const {
      segmentName,
      // segmentType,
      segmentRetailer,
      startDate,
      endDate,
      testPopulationPercent,
      numSegments,
      // numCampaignsPerSession,
      numCampaignsOverTime,
      numCampaignsTimePeriod,
      totalCampaignValueOverTime,
      totalCampaignValueTimePeriod,
      testVariable,
      testVariableTimePeriod,
      stepAmount,
      popOffset,
    } = this.state.errors;

    const {
      currentStartDate,
      currentEndDate
    } = this.state;

    return (
      <div className="ProviderSegmentationInfo">
        <Form
          onSubmit={(data) => this.handleFormSubmit(data)}
          includeEmpty
        >
          <Title
            className="text-center"
            text="Content Distribution Control Panel"
          />

          <Container>
            <Title
              text="Create Segmentation"
              textClassName="ProviderSegmentationInfo_smallTitle"
            />
            <hr className="ProviderSegmentationInfo_hr" />
            <FormGroup row color={segmentName.state}>
              <Col xs={12} sm={3}>
                <Label size="lg">Name:</Label>
              </Col>
              <Col xs={12} sm={9}>
                <Input
                  name="segmentName"
                  type="text"
                  state={segmentName.state}
                  placeholder={'My super sweet segment'}
                  size="lg" />
              </Col>
            </FormGroup>

            <FormGroup row>
              <Col xs={12} sm={3}>
                <Label size="lg">Description:</Label>
              </Col>
              <Col xs={12} sm={9}>
                <Input
                  name="segmentDescription"
                  placeholder={'My segment is super duper sweet'}
                  type="textarea"
                  size="lg" />
              </Col>
            </FormGroup>

            <FormGroup row color={segmentRetailer.state}>
              <Col xs={12} sm={3} md={3}>
                <Label size="lg">Retailer:</Label>
              </Col>
              <Col xs={12} sm={9} md={3}>
                <Input
                  name="segmentRetailer"
                  type="select"
                  state={segmentRetailer.state}
                  size="lg"
                >
                  {this.props.retailers && this.props.retailers.map((r,i) => (
                    <option key={i}>{r.name} - {r.id}</option>
                  ))}

                  {(!this.props.retailers || this.props.retailers.length === 0) && (
                    <option>No Retailers... uh oh.</option>
                  )}
                </Input>
              </Col>
            </FormGroup>

            {/*<FormGroup row color={segmentType.state}>
              <Col xs={12} sm={3} md={3}>
                <Label size="lg">Type:</Label>
              </Col>
              <Col xs={12} sm={9} md={3}>
                <Input
                  name="segmentType"
                  state={segmentType.state}
                  type="select"
                  size="lg"
                >
                  <option>Randomized</option>
                  <option>Not Randomized</option>
                  <option>Random Option</option>
                  <option>Fake Option</option>
                </Input>
              </Col>
            </FormGroup>*/}

            <FormGroup row color={startDate.state}>
              <Col xs={12} sm={3} md={3}>
                <Label size="lg">Start Date:</Label>
              </Col>
              <Col xs={12} sm={9} md={6}>
                <DateInput
                  className='form-control'
                  minDate={moment()}
                  maxDate={currentEndDate}
                  selected={currentStartDate}
                  onChange={(d) => this.setState({currentStartDate:d})}
                />
              </Col>
            </FormGroup>

            <FormGroup row color={endDate.state}>
              <Col xs={12} sm={3} md={3}>
                <Label size="lg">End Date:</Label>
              </Col>
              <Col xs={12} sm={9} md={6}>
                <DateInput
                  className='form-control'
                  minDate={currentStartDate}
                  selected={currentEndDate}
                  onChange={(d) => this.setState({currentEndDate:d})}
                />
              </Col>
            </FormGroup>
          </Container>

          <Container>
            <Title
              text="Population Size"
              textClassName="ProviderSegmentationInfo_smallTitle"
            />
            <hr className="ProviderSegmentationInfo_hr" />

            <FormGroup row color={testPopulationPercent.state}>
              <Col xs={12} sm={5} md={4}>
                <Label size="lg">Test Population, Percentage of Total:</Label>
              </Col>
              <Col xs={12} sm={7} md={4}>
              <InputGroup>
                <InputGroupAddon>%</InputGroupAddon>
                <Input
                  name="testPopulationPercent"
                  state={testPopulationPercent.state}
                  type="number"
                  placeholder="20"
                  min={0}
                  max={100}
                  step={10}
                  size="lg"
                />
              </InputGroup>
              </Col>
            </FormGroup>

            <FormGroup row color={numSegments.state}>
              <Col xs={12} sm={5} md={4}>
                <Label size="lg">Number of Segments in Test Population:</Label>
              </Col>
              <Col xs={12} sm={7} md={4}>
                <Input
                  name="numSegments"
                  state={numSegments.state}
                  type="number"
                  placeholder="10"
                  size="lg"
                />
              </Col>
            </FormGroup>
          </Container>

          <Container>
            <Title
              text="Control Parameters - All Populations"
              textClassName="ProviderSegmentationInfo_smallTitle"
            />
            <hr className="ProviderSegmentationInfo_hr" />

            {/* <FormGroup row color={numCampaignsPerSession.state}>
              <Label size="lg">Maximum Number of Campaigns per Session:</Label>
              <Col xs={12} lg={5}>
                <Input
                  name="numCampaignsPerSession"
                  state={numCampaignsPerSession.state}
                  type="number"
                  placeholder="3"
                  size="lg"
                />
                <span>per User Session</span>
              </Col>
            </FormGroup> */}

            <Row>
              <Label
                xs={12}
                lg={7}
                size="lg"
              >
                Maximum Number of Campaigns Presented over Time:
              </Label>
              <Col xs={12} lg={5}>
                <Row>
                  <Col xs={5}>
                    <FormGroup color={numCampaignsOverTime.state}>
                      <Input
                        name="numCampaignsOverTime"
                        state={numCampaignsOverTime.state}
                        type="number"
                        placeholder="5"
                      />
                    </FormGroup>
                  </Col>

                  <Col xs={2}><span>per</span></Col>

                  <Col xs={5}>
                    <FormGroup color={numCampaignsTimePeriod.state}>
                      <Input
                        name="numCampaignsTimePeriod"
                        state={numCampaignsTimePeriod.state}
                        type="select"
                      >
                        <option>Day</option>
                        <option>Week</option>
                        <option>Month</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>

            <FormGroup row>
              <Label xs={12} lg={7} size="lg">
                Maximum Total Campaign Value Over Time:
              </Label>
              <Col xs={12} lg={5}>
                <Row>
                  <Col xs={5}>
                    <FormGroup color={totalCampaignValueOverTime.state}>
                      <InputGroup>
                        <InputGroupAddon>$</InputGroupAddon>
                        <Input
                          name="totalCampaignValueOverTime"
                          state={totalCampaignValueOverTime.state}
                          type="number"
                          placeholder="2.50"
                          step="0.10"
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>

                  <Col xs={2}><span>per</span></Col>

                  <Col xs={5}>
                    <FormGroup color={totalCampaignValueTimePeriod.state}>
                      <Input
                        name="totalCampaignValueTimePeriod"
                        state={totalCampaignValueTimePeriod.state}
                        type="select"
                        defaultValue="Week"
                      >
                        <option>Day</option>
                        <option>Week</option>
                        <option>Month</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </FormGroup>
          </Container>

          {/* Test Population Parameters */}
          <Container>
            <Title
              textClassName="ProviderSegmentationInfo_smallTitle"
              text="Test Population Parameters"
            />
            <hr className="ProviderSegmentationInfo_hr" />

            <Row>
              <Col xs={12} lg={6}>
                <FormGroup row color={testVariable.state}>
                  <Label xs={12} lg={4} size="lg">
                    Test Variable:
                  </Label>

                  <Col xs={12} lg={8}>
                    <Input
                      name="testVariable"
                      state={testVariable.state}
                      type="select"
                    >
                      <option>Campaign Value per time period</option>
                    </Input>
                  </Col>
                </FormGroup>
              </Col>

              <Col xs={12} lg={6}>
                <FormGroup row color={testVariableTimePeriod.state}>
                  <Label xs={12} lg={6} size="lg">
                    Time Period:
                  </Label>

                  <Col xs={12} lg={6}>
                    <Input
                      name="testVariableTimePeriod"
                      state={testVariableTimePeriod.state}
                      type="select"
                    >
                      <option>Day</option>
                      <option>Week</option>
                      <option>Month</option>
                    </Input>
                  </Col>
                </FormGroup>
              </Col>
            </Row>

            {/* Step Amount */}
            <FormGroup row color={stepAmount.state}>
              <Col xs={12} lg={6}>
                <Label size="lg">Step Amount:</Label>
                <div>increase or decrease in value within test segments</div>
              </Col>
              <Col xs={12} lg={6}>
                <Row>
                  <Col xs={2}>
                    <span style={{fontSize: '1.5rem'}}>
                      +/-
                    </span>
                  </Col>
                  <Col xs={10}>
                    <InputGroup>
                      <InputGroupAddon>$</InputGroupAddon>
                      <Input
                        name="stepAmount"
                        state={stepAmount.state}
                        type="number"
                        placeholder="0.05"
                        step="0.01"
                        size="lg"
                      />
                    </InputGroup>
                  </Col>
                </Row>
              </Col>
            </FormGroup>

            {/* Population Offset */}
            <FormGroup row color={popOffset.state}>
              <Col xs={12} lg={6}>
                <Label size="lg">Population Offset:</Label>
              </Col>
              <Col xs={12} lg={6}>
                <Input
                  name="popOffset"
                  state={popOffset.state}
                  type="number"
                  placeholder="0"
                  step="0.01"
                  size="lg"
                />
              </Col>
            </FormGroup>
          </Container>




          <div style={{textAlign: 'right'}}>
            <Button
              color="primary"
              style={{fontSize: '1rem', padding: '1rem 2rem'}}
            >
              Save
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

export default ProviderSegmentationInfo;



// WEBPACK FOOTER //
// ./src/routes/ProviderSegmentationInfo/components/ProviderSegmentationInfo.js